/**
 * Shared app header (brand + nav) Tailwind classes.
 * Landscape-short overrides match the previous CSS media query:
 * (min-width: 1024px) and (max-height: 768px).
 *
 * Nav hit / icon / label come from chromeShell; header adds hover/focus tones.
 * Nav hit height stays fixed; width follows label text. Horizontal padding matches px-page-x.
 * bp-lg / bp-2xl adjust brand type and nav item gaps only.
 *
 * Hover styles are gated with (hover: hover) and (pointer: fine) so touch
 * taps do not leave sticky PC hover. Accent on keyboard focus uses
 * :focus-visible / group-has-[:focus-visible] instead of :focus / :focus-within.
 */

import { chromeShell } from "./chromeShell";

export const headerShell = {
    root:
        "box-border z-10 flex w-full shrink-0 flex-col items-stretch justify-between gap-0.5 border-0 border-b border-solid border-border bg-surface px-page-x py-0.5 font-sans text-text-primary shadow-none bp-lg:flex-row bp-lg:items-center bp-lg:gap-0",
    logoContainer:
        "flex items-center justify-center gap-2 text-center bp-lg:justify-start bp-lg:text-left",
    logoIcon:
        "block size-5 shrink-0 object-contain bp-lg:size-6 bp-2xl:size-7 [@media(min-width:1024px)_and_(max-height:768px)]:size-5",
    logoText:
        "whitespace-nowrap text-base font-semibold bp-lg:text-xl bp-2xl:text-2xl [@media(min-width:1024px)_and_(max-height:768px)]:text-base",
    navContainer: "flex items-center justify-center bp-lg:justify-end",
    nav: "flex flex-wrap items-center justify-evenly gap-2 bp-lg:gap-3",
    projectNav:
        "flex items-center gap-1 border-0 border-r-2 border-solid border-border pr-3 bp-lg:gap-2 bp-lg:pr-4 bp-xl:gap-2.5 bp-2xl:gap-3",
    generalNav: "ml-2 flex items-center gap-1 bp-lg:ml-3 bp-lg:gap-2 bp-xl:gap-2.5 bp-2xl:gap-3",
    navItem: `${chromeShell.navHit} [@media(hover:hover)_and_(pointer:fine)]:hover:bg-accent-10`,
    navLink:
        "flex h-full w-full flex-col items-center justify-center gap-0.5 text-text-muted no-underline hover:no-underline focus:no-underline focus-visible:text-accent focus-visible:no-underline [@media(hover:hover)_and_(pointer:fine)]:hover:text-accent",
    navIcon: `material-icons ${chromeShell.navIcon}`,
    navIconTone:
        "text-text-muted group-has-[:focus-visible]:text-accent [@media(hover:hover)_and_(pointer:fine)]:group-hover:text-accent",
    navIconActive: "text-accent",
    navText: chromeShell.navLabel,
    navTextTone:
        "text-text-muted group-has-[:focus-visible]:text-accent [@media(hover:hover)_and_(pointer:fine)]:group-hover:text-accent",
    navTextActive: "text-accent",
};
